import { createReducer } from '@reduxjs/toolkit'
import {
  resetVisualizationStateToDefault
  setUseEndDateAttribute
  setSelectedAttribute
  setSelectedEndAttribute
  setStepSize
} from 'Actions/timeVisualization'

initialState = {
  useEndDateAttribute: false
  selectedAttribute: undefined
  selectedEndAttribute: undefined
  stepSize: 'day'
}

export default createReducer(initialState, {
  [resetVisualizationStateToDefault]: (state) ->
    state.selectedAttribute = initialState.selectedAttribute
    state.selectedEndAttribute = initialState.selectedEndAttribute
    undefined
  [setUseEndDateAttribute]: (state, action) ->
    state.useEndDateAttribute = action.payload
    undefined
  [setSelectedAttribute]: (state, action) ->
    state.selectedAttribute = action.payload
    undefined
  [setSelectedEndAttribute]: (state, action) ->
    state.selectedEndAttribute = action.payload
    undefined
  [setStepSize]: (state, action) ->
    state.stepSize = action.payload
    undefined
})
